"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.includes");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _part2 = _interopRequireDefault(require("../utils/part"));

var vo = function vo(o, v, cb) {
  return v !== undefined && ['$ne', '$gt', '$gte', '$lt', '$lte'].includes(o) ? cb(o) : undefined;
};

var cmpToQuery = function cmpToQuery(operator, fieldName, value) {
  return vo(operator, value, function (mark) {
    return (0, _part2.default)(fieldName, (0, _defineProperty2.default)({}, mark, value));
  });
};

var _default = cmpToQuery;
exports.default = _default;